import DE from './de/translations.json';
import EN from './en/translations.json';
import FR from './fr/translations.json';

export default {
  DE,
  EN,
  FR,
};

declare module 'react-i18next' {
  interface Resources {
    'templates-add': typeof EN;
  }
}
